import { request } from "./request";

export function resetPassword(_ref) {var email = _ref.email,csrfToken = _ref.csrfToken;
  var requestUrl = process.env.API_URL + '/password_reset/';

  var requestBody = new FormData();
  requestBody.set('csrfmiddlewaretoken', csrfToken);
  requestBody.set('email', email);
  requestBody.set('next', '');

  var requestHeaders = {
    'Accept': 'text/html,application/xhtml+xml,application/xml;q=0.9,image/webp,image/apng,*/*;q=0.8',
    'Content-Type': 'application/x-www-form-urlencoded' };


  var otherParams = { mode: 'no-cors' };

  return request('get', requestUrl, null, requestHeaders).
  then(function (res) {
    console.warn('res', res);
    return request('post', requestUrl, requestBody, requestHeaders, otherParams);
  }).
  then(function (data) {
    console.warn('restore password success', data);
    return data;
  });
}